export const frAppsMobiles = {
  titre: 'Apps mobiles',
  texte:
    'Réglez la version minimale et la version conseillée des apps iOS et Android. Une app sous la minimale est bloquée ; sous la conseillée, elle affiche seulement un bandeau.',
  lectureSeule:
    'Lecture seule : régler les versions est réservé à l’exploitation et à la direction de Venio.',
  erreurChargement: 'Impossible de charger les versions des apps.',
  plateformes: { ios: 'iOS', android: 'Android' },
  etat: {
    aucune: 'Aucune exigence',
    minimale: 'Bloque sous la version {{version}}',
  },
  rail: {
    titre: 'Effet de ce réglage',
    aucune: 'Toutes les versions sont admises.',
    bloquee: 'Bloquées sous la version {{version}}',
    bandeau: 'Bandeau de mise à jour de la version {{de}} à la {{a}}',
    bandeauSous: 'Bandeau de mise à jour sous la version {{version}}',
    admise: 'Admises dès la version {{version}}',
    aJour: 'À jour dès la version {{version}}',
  },
  champs: {
    minimale: 'Version minimale',
    conseillee: 'Version conseillée',
    urlBoutique: 'Fiche de l’app dans la boutique',
  },
  aides: {
    minimale: 'Sous cette version, l’app est bloquée. Laissez vide pour ne rien exiger.',
    conseillee: 'Sous cette version, l’app invite à se mettre à jour, sans bloquer.',
    urlBoutique:
      'Adresse https de la fiche, où l’app renvoie. Laissez vide tant que l’app n’est pas publiée.',
  },
  exemples: { version: '1.2.3', url: 'https://' },
  erreurs: {
    version: 'Écrivez une version comme 1, 1.2 ou 1.2.3.',
    url: 'Saisissez une adresse complète qui commence par https://.',
    conseilleeSousMinimale: 'La version conseillée ne peut pas être inférieure à la minimale.',
  },
  enregistrer: 'Enregistrer',
  enCours: 'Enregistrement…',
  succes: 'Versions {{plateforme}} enregistrées. Les apps les liront d’ici une minute.',
  conflit:
    'Quelqu’un a modifié ces versions entre-temps. Elles ont été rechargées : vérifiez, puis recommencez.',
  journalIndisponible:
    'Le journal est indisponible : rien n’a été enregistré. Réessayez dans un instant.',
  erreurGenerique: 'Ce réglage a été refusé. Vérifiez les valeurs, puis réessayez.',
  confirmation: {
    titre: 'Relever la version minimale pour {{plateforme}} à la {{version}} ?',
    texte:
      'Les apps sous cette version seront bloquées d’ici une minute. Leurs utilisateurs devront les mettre à jour pour continuer.',
    confirmer: 'Relever et bloquer',
    annuler: 'Annuler',
    fermer: 'Fermer',
  },
};

export const enAppsMobiles: typeof frAppsMobiles = {
  titre: 'Mobile apps',
  texte:
    'Set the minimum and recommended versions of the iOS and Android apps. An app below the minimum is blocked; below the recommended one, it only shows a banner.',
  lectureSeule: 'Read only: setting versions is reserved to Venio operations and management.',
  erreurChargement: 'Unable to load the app versions.',
  plateformes: { ios: 'iOS', android: 'Android' },
  etat: {
    aucune: 'No requirement',
    minimale: 'Blocks below version {{version}}',
  },
  rail: {
    titre: 'Effect of this setting',
    aucune: 'Every version is allowed.',
    bloquee: 'Blocked below version {{version}}',
    bandeau: 'Update banner from version {{de}} to {{a}}',
    bandeauSous: 'Update banner below version {{version}}',
    admise: 'Allowed from version {{version}}',
    aJour: 'Up to date from version {{version}}',
  },
  champs: {
    minimale: 'Minimum version',
    conseillee: 'Recommended version',
    urlBoutique: 'App page in the store',
  },
  aides: {
    minimale: 'Below this version, the app is blocked. Leave empty to require nothing.',
    conseillee: 'Below this version, the app asks to update, without blocking.',
    urlBoutique:
      'The https address of the page the app sends people to. Leave empty until the app is published.',
  },
  exemples: { version: '1.2.3', url: 'https://' },
  erreurs: {
    version: 'Enter a version such as 1, 1.2 or 1.2.3.',
    url: 'Enter a full address that starts with https://.',
    conseilleeSousMinimale: 'The recommended version cannot be lower than the minimum.',
  },
  enregistrer: 'Save',
  enCours: 'Saving…',
  succes: '{{plateforme}} versions saved. The apps will read them within a minute.',
  conflit:
    'Someone changed these versions in the meantime. They have been reloaded: check them, then try again.',
  journalIndisponible: 'The log is unavailable: nothing was saved. Try again in a moment.',
  erreurGenerique: 'This setting was refused. Check the values, then try again.',
  confirmation: {
    titre: 'Raise the minimum version for {{plateforme}} to {{version}}?',
    texte:
      'Apps below this version will be blocked within a minute. Their users will have to update to carry on.',
    confirmer: 'Raise and block',
    annuler: 'Cancel',
    fermer: 'Close',
  },
};
